import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { colors, cssBreakpoints, transition } from '#/theme/theme';

const SmallHolder = styled.div`
  padding: 24px;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: white;
  box-shadow: 0 0 20px rgb(0 0 0 / 10%);

  @media (min-width: ${cssBreakpoints.mdUp}) {
    padding: 48px;
  }

  &[data-has-url] {
    color: ${colors.mediumContentGrey};
    transition: all ${transition};
    cursor: pointer;
    a {
      color: inherit;
      text-decoration: none;
      transition: all ${transition};
      &:hover {
        text-decoration: none;
      }
    }
    &:hover {
      box-shadow: 0 0 6px rgb(0 0 0 / 20%);
      a {
        color: ${colors.brandBlue};
      }
    }
  }
`;

type Props = {
  withLinks?: boolean;
  large?: boolean;
  hasUrl: boolean;
  children: ReactNode;
};

export const CmsThreeStepCtaBlockStepBox = ({
  withLinks,
  large,
  hasUrl,
  children,
}: Props) => {
  if (withLinks && !large) {
    return (
      <SmallHolder data-has-url={hasUrl ? true : undefined}>
        {children}
      </SmallHolder>
    );
  }

  return <div style={{ width: '100%' }}>{children}</div>;
};
